<template>
  <div>
    <div v-if="this.route.query.uid || (this.currentUser && this.currentUser.type == 'administrator')" class="container mainContent">
      <h2>Scientific Committee Registration</h2>
      <form class="form-horizontal" v-on:submit.prevent="scRegister">

        <h3 v-if="this.authData && currentUser.type == 'administrator'">System Data</h3>
        <div class="form-group" v-if="this.authData && currentUser.type == 'administrator'">
          <label for="uid" class="col-sm-2 control-label">uid</label>
          <div class="col-sm-10">
            <p class="form-control-static">{{ route.query.uid }}</p>
          </div>
        </div>

        <h3>Personal Details</h3>
        <div class="form-group">
          <label for="title" class="col-sm-2 control-label">Title</label>
          <div class="col-sm-10">
            <select name="title" class="form-control" v-model="registrationData.title">
              <option value=""></option>
              <option value="1">Mr</option>
              <option value="2">Mrs</option>
              <option value="3">Miss</option>
              <option value="4">Ms</option>
              <option value="5">Mx (gender-netural)</option>
              <option value="6">Dr</option>
              <option value="7">Professor</option>
              <option value="8">The Rt Revd Dr</option>
              <option value="9">The Most Revd</option>
              <option value="10">The Rt Revd</option>
              <option value="11">The Revd Canon</option>
              <option value="12">The Revd</option>
              <option value="13">The Rt Revd Professor</option>
              <option value="14">The Ven</option>
              <option value="15">The Most Revd Dr</option>
              <option value="16">Rabbi</option>
              <option value="17">Canon</option>
              <option value="18">Dame</option>
              <option value="19">Chief</option>
              <option value="20">Sister</option>
              <option value="21">Reverend</option>
              <option value="22">Major</option>
              <option value="23">Other</option>
              <option value="24">Cllr</option>
              <option value="25">Sir</option>
              <option value="26">Rt Hon Lord</option>
              <option value="27">Rt Hon</option>
              <option value="28">Lord</option>
              <option value="29">Viscount</option>
              <option value="30">Viscountess</option>
              <option value="31">Baroness</option>
              <option value="32">Captain</option>
              <option value="33">Master</option>
              <option value="34">Very Revd</option>
              <option value="35">Lady</option>
              <option value="36">MP</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label for="forename" class="col-sm-2 control-label">First name</label>
          <div class="col-sm-10">
            <input type="text" class="form-control" id="forename" placeholder="First name" v-model="registrationData.forename">
          </div>
        </div>
        <div class="form-group">
          <label for="surname" class="col-sm-2 control-label">Surname</label>
          <div class="col-sm-10">
            <input type="text" class="form-control" id="surname" placeholder="Surname" v-model="registrationData.surname">
          </div>
        </div>
        <div class="form-group">
          <label for="sex" class="col-sm-2 control-label">Sex</label>
          <div class="col-sm-10">
            <label class="radio-inline">
              <input type="radio" name="sex" value="female" v-model="registrationData.sex"> Female
            </label>
            <label class="radio-inline">
              <input type="radio" name="sex" value="male" v-model="registrationData.sex"> Male
            </label>
          </div>
        </div>
        <div class="form-group">
          <label for="email" class="col-sm-2 control-label">Email</label>
          <div class="col-sm-10">
            <input type="email" class="form-control" id="email" placeholder="Email" v-model="registrationData.email">
          </div>
        </div>
        <div class="form-group">
          <label for="country" class="col-sm-2 control-label">Country</label>
          <div class="col-sm-10">
            <select name="country" class="form-control" v-model="registrationData.country">
              <option value=""></option>
              <option value="AFG">Afghanistan</option>
              <option value="ALB">Albania</option>
              <option value="DZA">Algeria</option>
              <option value="ASM">American Samoa</option>
              <option value="AND">Andorra</option>
              <option value="AGO">Angola</option>
              <option value="AIA">Anguilla</option>
              <option value="ATA">Antarctica</option>
              <option value="ATG">Antigua And Barbuda</option>
              <option value="ARG">Argentina</option>
              <option value="ARM">Armenia</option>
              <option value="ABW">Aruba</option>
              <option value="AUS">Australia</option>
              <option value="AUT">Austria</option>
              <option value="AZE">Azerbaijan</option>
              <option value="BHS">Bahamas</option>
              <option value="BHR">Bahrain</option>
              <option value="BGD">Bangladesh</option>
              <option value="BRB">Barbados</option>
              <option value="BLR">Belarus</option>
              <option value="BEL">Belgium</option>
              <option value="BLZ">Belize</option>
              <option value="BEN">Benin</option>
              <option value="BMU">Bermuda</option>
              <option value="BTN">Bhutan</option>
              <option value="BOL">Bolivia</option>
              <option value="BIH">Bosnia And Herzegowina</option>
              <option value="BWA">Botswana</option>
              <option value="BVT">Bouvet Island</option>
              <option value="BRA">Brazil</option>
              <option value="IOT">British Indian Ocean Territory</option>
              <option value="BRN">Brunei Darussalam</option>
              <option value="BGR">Bulgaria</option>
              <option value="BFA">Burkina Faso</option>
              <option value="BDI">Burundi</option>
              <option value="KHM">Cambodia</option>
              <option value="CMR">Cameroon</option>
              <option value="CAN">Canada</option>
              <option value="CPV">Cape Verde</option>
              <option value="CYM">Cayman Islands</option>
              <option value="CAF">Central African Republic</option>
              <option value="TCD">Chad</option>
              <option value="CHL">Chile</option>
              <option value="CHN">China</option>
              <option value="CXR">Christmas Island</option>
              <option value="CCK">Cocos (Keeling) Islands</option>
              <option value="COL">Colombia</option>
              <option value="COM">Comoros</option>
              <option value="COG">Congo</option>
              <option value="COK">Cook Islands</option>
              <option value="CRI">Costa Rica</option>
              <option value="CIV">Cote D'ivoire</option>
              <option value="HRV">Croatia</option>
              <option value="CUB">Cuba</option>
              <option value="CYP">Cyprus</option>
              <option value="CZE">Czech Republic</option>
              <option value="DNK">Denmark</option>
              <option value="DJI">Djibouti</option>
              <option value="DMA">Dominica</option>
              <option value="DOM">Dominican Republic</option>
              <option value="TMP">East Timor</option>
              <option value="ECU">Ecuador</option>
              <option value="EGY">Egypt</option>
              <option value="SLV">El Salvador</option>
              <option value="GNQ">Equatorial Guinea</option>
              <option value="ERI">Eritrea</option>
              <option value="EST">Estonia</option>
              <option value="ETH">Ethiopia</option>
              <option value="FLK">Falkland Islands (Malvinas)</option>
              <option value="FRO">Faroe Islands</option>
              <option value="FJI">Fiji</option>
              <option value="FIN">Finland</option>
              <option value="FRA">France</option>
              <option value="FXX">France, Metropolitan</option>
              <option value="GUF">French Guiana</option>
              <option value="PYF">French Polynesia</option>
              <option value="ATF">French Southern Territories</option>
              <option value="GAB">Gabon</option>
              <option value="GMB">Gambia</option>
              <option value="GEO">Georgia</option>
              <option value="DEU">Germany</option>
              <option value="GHA">Ghana</option>
              <option value="GIB">Gibraltar</option>
              <option value="GRC">Greece</option>
              <option value="GRL">Greenland</option>
              <option value="GRD">Grenada</option>
              <option value="GLP">Guadeloupe</option>
              <option value="GUM">Guam</option>
              <option value="GTM">Guatemala</option>
              <option value="GIN">Guinea</option>
              <option value="GNB">Guinea-Bissau</option>
              <option value="GUY">Guyana</option>
              <option value="HTI">Haiti</option>
              <option value="HMD">Heard And Mc Donald Islands</option>
              <option value="HND">Honduras</option>
              <option value="HKG">Hong Kong</option>
              <option value="HUN">Hungary</option>
              <option value="ISL">Iceland</option>
              <option value="IND">India</option>
              <option value="IDN">Indonesia</option>
              <option value="IRN">Iran (Islamic Republic Of)</option>
              <option value="IRQ">Iraq</option>
              <option value="IRL">Ireland</option>
              <option value="ISR">Israel</option>
              <option value="ITA">Italy</option>
              <option value="JAM">Jamaica</option>
              <option value="JPN">Japan</option>
              <option value="JOR">Jordan</option>
              <option value="KAZ">Kazakhstan</option>
              <option value="KEN">Kenya</option>
              <option value="KIR">Kiribati</option>
              <option value="PRK">Korea, Democratic People's Republic Of</option>
              <option value="KOR">Korea, Republic Of</option>
              <option value="KWT">Kuwait</option>
              <option value="KGZ">Kyrgyzstan</option>
              <option value="LAO">Lao People's Democratic Republic</option>
              <option value="LVA">Latvia</option>
              <option value="LBN">Lebanon</option>
              <option value="LSO">Lesotho</option>
              <option value="LBR">Liberia</option>
              <option value="LBY">Libyan Arab Jamahiriya</option>
              <option value="LIE">Liechtenstein</option>
              <option value="LTU">Lithuania</option>
              <option value="LUX">Luxembourg</option>
              <option value="MAC">Macau</option>
              <option value="MKD">Macedonia, The Former Yugoslav Republic Of</option>
              <option value="MDG">Madagascar</option>
              <option value="MWI">Malawi</option>
              <option value="MYS">Malaysia</option>
              <option value="MDV">Maldives</option>
              <option value="MLI">Mali</option>
              <option value="MLT">Malta</option>
              <option value="MHL">Marshall Islands</option>
              <option value="MTQ">Martinique</option>
              <option value="MRT">Mauritania</option>
              <option value="MUS">Mauritius</option>
              <option value="MYT">Mayotte</option>
              <option value="MEX">Mexico</option>
              <option value="FSM">Micronesia (Federated States Of)</option>
              <option value="MDA">Moldova, Republic Of</option>
              <option value="MCO">Monaco</option>
              <option value="MNG">Mongolia</option>
              <option value="MSR">Montserrat</option>
              <option value="MAR">Morocco</option>
              <option value="MOZ">Mozambique</option>
              <option value="MMR">Myanmar</option>
              <option value="NAM">Namibia</option>
              <option value="NRU">Nauru</option>
              <option value="NPL">Nepal</option>
              <option value="NLD">Netherlands</option>
              <option value="ANT">Netherlands Antilles</option>
              <option value="NCL">New Caledonia</option>
              <option value="NZL">New Zealand</option>
              <option value="NIC">Nicaragua</option>
              <option value="NER">Niger</option>
              <option value="NGA">Nigeria</option>
              <option value="NIU">Niue</option>
              <option value="NFK">Norfolk Island</option>
              <option value="MNP">Northern Mariana Islands</option>
              <option value="NOR">Norway</option>
              <option value="OMN">Oman</option>
              <option value="PAK">Pakistan</option>
              <option value="PLW">Palau</option>
              <option value="PAN">Panama</option>
              <option value="PNG">Papua New Guinea</option>
              <option value="PRY">Paraguay</option>
              <option value="PER">Peru</option>
              <option value="PHL">Philippines</option>
              <option value="PCN">Pitcairn</option>
              <option value="POL">Poland</option>
              <option value="PRT">Portugal</option>
              <option value="PRI">Puerto Rico</option>
              <option value="QAT">Qatar</option>
              <option value="REU">Reunion</option>
              <option value="ROM">Romania</option>
              <option value="RUS">Russian Federation</option>
              <option value="RWA">Rwanda</option>
              <option value="KNA">Saint Kitts And Nevis</option>
              <option value="LCA">Saint Lucia</option>
              <option value="VCT">Saint Vincent And The Grenadines</option>
              <option value="WSM">Samoa</option>
              <option value="SMR">San Marino</option>
              <option value="STP">Sao Tome And Principe</option>
              <option value="SAU">Saudi Arabia</option>
              <option value="SEN">Senegal</option>
              <option value="SYC">Seychelles</option>
              <option value="SLE">Sierra Leone</option>
              <option value="SGP">Singapore</option>
              <option value="SVK">Slovakia</option>
              <option value="SVN">Slovenia</option>
              <option value="SLB">Solomon Islands</option>
              <option value="SOM">Somalia</option>
              <option value="ZAF">South Africa</option>
              <option value="SGS">South Georgia And The South Sandwich Islands</option>
              <option value="ESP">Spain</option>
              <option value="LKA">Sri Lanka</option>
              <option value="SHN">St. Helena</option>
              <option value="SPM">St. Pierre And Miquelon</option>
              <option value="SDN">Sudan</option>
              <option value="SUR">Suriname</option>
              <option value="SJM">Svalbard And Jan Mayen Islands</option>
              <option value="SWZ">Swaziland</option>
              <option value="SWE">Sweden</option>
              <option value="CHE">Switzerland</option>
              <option value="SYR">Syrian Arab Republic</option>
              <option value="TWN">Taiwan, Province Of China</option>
              <option value="TJK">Tajikistan</option>
              <option value="TZA">Tanzania, United Republic Of</option>
              <option value="THA">Thailand</option>
              <option value="TGO">Togo</option>
              <option value="TKL">Tokelau</option>
              <option value="TON">Tonga</option>
              <option value="TTO">Trinidad And Tobago</option>
              <option value="TUN">Tunisia</option>
              <option value="TUR">Turkey</option>
              <option value="TKM">Turkmenistan</option>
              <option value="TCA">Turks And Caicos Islands</option>
              <option value="TUV">Tuvalu</option>
              <option value="UGA">Uganda</option>
              <option value="UKR">Ukraine</option>
              <option value="ARE">United Arab Emirates</option>
              <option value="GBR">United Kingdom</option>
              <option value="USA">United States</option>
              <option value="UMI">United States Minor Outlying Islands</option>
              <option value="URY">Uruguay</option>
              <option value="UZB">Uzbekistan</option>
              <option value="VUT">Vanuatu</option>
              <option value="VAT">Vatican City State (Holy See)</option>
              <option value="VEN">Venezuela</option>
              <option value="VNM">Viet Nam</option>
              <option value="VGB">Virgin Islands (British)</option>
              <option value="VIR">Virgin Islands (U.S.)</option>
              <option value="WLF">Wallis And Futuna Islands</option>
              <option value="ESH">Western Sahara</option>
              <option value="YEM">Yemen</option>
              <option value="YUG">Yugoslavia</option>
              <option value="ZAR">Zaire</option>
              <option value="ZMB">Zambia</option>
              <option value="ZWE">Zimbabwe</option>
            </select>
          </div>
        </div>

        <h3>Professional Details</h3>
        <div class="form-group">
          <label for="organisation" class="col-sm-2 control-label">Organisation</label>
          <div class="col-sm-10">
            <input type="text" class="form-control" id="organisation" placeholder="Organisation" v-model="registrationData.organisation">
          </div>
        </div>
        <div class="form-group">
          <label for="speciality" class="col-sm-2 control-label">Speciality</label>
          <div class="col-sm-10">
            <input type="text" class="form-control" id="speciality" placeholder="Speciality" v-model="registrationData.speciality">
          </div>
        </div>

        <h3>Website Registration</h3>
        <div class="form-group">
          <label for="password" class="col-sm-2 control-label">Password</label>
          <div class="col-sm-10">
            <input type="password" class="form-control" id="password" placeholder="Password" v-model="registrationData.password1">
          </div>
        </div>
        <div class="form-group">
          <label for="confirmpassword" class="col-sm-2 control-label">Confirm Password</label>
          <div class="col-sm-10">
            <input type="password" class="form-control" id="confirmpassword" placeholder="Confirm Password" v-model="registrationData.password2">
          </div>
        </div>

        <h3>Agreement</h3>
        <div class="form-group">
          <label class="col-sm-2 control-label"><input type="checkbox" id="agreement" value="true" v-model="registrationData.agreement"></label>
          <div class="col-sm-10">
            <p class="form-control-static">By checking this box you accept that...</p>
          </div>
        </div>

        <div class="form-group">
          <div class="col-sm-12">
            <button type="submit" class="btn btn-default btn-block btn-info btn-lg">Register</button>
          </div>
        </div>
      </form>

      <div class="alert alert-danger" role="alert" v-if="messageError">{{ messageError }}</div>
      <div class="alert alert-success" role="alert" v-if="messageSuccess">{{ messageSuccess }}</div>

    </div>
    <div v-else class="container mainContent">
      <h2>An error has occured</h2>
      <p>Sorry, but you're not authorised to view this page.</p>
    </div>
  </div>
</template>

<script>
  // global variables
  var regexEmail = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  var regexURL = /(\?|\&)([^=]+)\=([^&]+)$/
  var blankUser = { name: null,
                    email: null,
                    type: null};

  import Vuex from 'vuex';
  import { mapState } from 'vuex'
  import VuexFire from 'vuexfire';
  import firebase from 'firebase';
  // end global variables

  // firebase initialisation
  var db = firebase.database();
  // end firebase initialisation


  // helper functions
  // end helper functions

  export default {
    name: "scregister",
    computed: {
      ...mapState({
        // map e.g. this.authData to store.state.authData
        authData: 'authData',
        contacts: 'contacts',
        currentUser: 'currentUser',
        route: 'route',
      })
    },
    data () {
      return {
        txtEmail: '',
        txtPassword: '',
        messageError: null,
        messageSuccess: null,
        registrationData: {forename: '',
                          surname: '',
                          type: '',
                          sex: '',
                          email: '',
                          country: '',
                          organisation: '',
                          speciality: '',
                          password1: '',
                          password2: '',
                          agreement: false}
      }
    },
    methods: {
      scRegister: function(evt) { // validates user details and registers scientific committee member
        var $target = $(event.target);
        var formData = this.registrationData;
        this.messageError = null;
        this.messageSuccess = null;

        if (formData.password1 != formData.password2) {
          this.messageError = 'Please ensure that both passwords match.';
          return;
        }
        if (formData.password1.length < 4) {
          this.messageError = 'Please enter a valid password.';
          return;
        }
        if (!regexEmail.test(formData.email)) {
          this.messageError = 'Please enter a valid email address.';
          return;
        }
        if (!formData.agreement) {
          this.messageError = 'You must agree to the terms and conditions before you are able to sign up.';
          return;
        }
        if (!this.route.query.uid) {
          this.messageError = 'The form you are trying to submit cannot be authenticated.  Please use the link as sent via email.';
          return;
        }

        $target.prop('disabled', true);
        firebase.database().ref('users/' + this.route.query.uid + "/").set({
          email: formData.email,
          created: firebase.database.ServerValue.TIMESTAMP
        }, $.proxy(function(error) {
          $target.prop('disabled', false);
          if (error) {
            var errorCode = error.code;
            var errorMessage = error.message;
            if (errorCode == 'PERMISSION_DENIED') {
              this.messageError = "The form you are trying to submit cannot be authenticated.  Please use the link as sent via email.";
            } else {
              this.messageError = 'Sorry. An error has occured';
            }
          } else {
            firebase.auth().createUserWithEmailAndPassword(formData.email, formData.password1).then( $.proxy(function(user) {
              firebase.database().ref('users/' + user.uid + "/").set({
                forename: formData.forename,
                surname: formData.surname,
                type: formData.type,
                sex: formData.sex,
                email: formData.email,
                country: formData.country,
                organisation: formData.organisation,
                speciality: formData.speciality,
                agreement: formData.agreement,
                scientificcommittee:  true, //pull from pre-auth
                ai2016: true,
                inviteaccepted: firebase.database.ServerValue.TIMESTAMP
              }, $.proxy(function(error) {
                if (error) {
                  var errorCode = error.code;
                  var errorMessage = error.message;
                  if (errorCode == 'PERMISSION_DENIED') {
                    this.messageError = error.message;
                  }
                } else {
                  firebase.database().ref('users/' + this.route.query.uid).remove();
                  firebase.database().ref('pre-auth/' + this.route.query.uid).remove();
                  this.messageSuccess = 'Thank you for submitting your details. You\'ve successfully registered and logged in.';
                  $target.closest("form").hide();
                }
              }, this));
            }, this)).catch( $.proxy(function(error) {
              var errorCode = error.code;
              var errorMessage = error.message;
              this.messageError = errorMessage;
              this.messageSuccess = null;
            }, this));
          }
        }, this));
      },
      focusNextField: function (event) { // moves focus to next input field
        $(event.target).parent().next("div").find("input").focus();
      }
    },
    components: {
    }
  }
</script>



/** WEBPACK FOOTER **
 ** scregister.vue?149e3536
 **/